export const fetchBookstore = async (termCode, crn) => {
    const url = 'https://preprod-apiweb.pasadena.edu/api/getbook';
    const options = {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
            bookstoreId: 2082,
            courses: [{ courseRefId: crn }],
            termId: termCode
        })
    };

    try {
        const response = await fetch(url, options);
        const data = await response.json();
        const section = data[0]?.courseSectionDTO?.[0];

        if (section?.courseSectionStatus?.status === 'FAIL') {
            return 'No Text Book';
        }
        const material = section?.courseMaterialResultsList?.[0];
        return {
            title: material?.title,
            edition: material?.edition,
            author: material?.author,
            link: `https://www.bkstr.com/pasadenastore/follett-discover-view/booklook?shopBy=discoverViewCourseRefId&bookstoreId=2082&courseRefId=${crn}&termId=${termCode}`,
            publisher: material?.publisher
        };
    } catch (error) {
        console.error(error);
        return 'Error fetching bookstore info';
    }
}